export const SET_LIST_EVENT = '@@LIST_EVENT/SET_LIST_EVENT';
export const SET_DICTIONARIES = '@@LIST_EVENT/SET_DICTIONARIES';
export const SET_IS_LOADING = '@@LIST_EVENT/SET_IS_LOADING';
